import fetchAssayBaseline from '../../utils/api_functions/assayBaselineFetch';

export const loadAllBaselineLogs = async (pipelineID, workspaceId, start, end, locations) => {
  let baselineLogs = [];
  let next = null;

  let ret = await fetchAssayBaseline({
    pipelineID,
    workspaceId,
    start,
    end,
    locations,
  });
  let ret_json = await ret.json();

  while (ret_json.length > 0) {
    baselineLogs = baselineLogs.concat(ret_json);

    const iteration_status = ret.headers.get('x-iteration-status')
    if (iteration_status) {
      try {
        const parsed_iteration_status = JSON.parse(iteration_status);
        next = parsed_iteration_status?.next;
      } catch (e) {
        break;
      }
    } else if (ret_json?.next) {
      try {
        next = JSON.parse(ret_json?.next);
      } catch (e) {
        break;
      }
    } else {
      break;
    }

    if (!next) {
      break;
    }

    // This await is not parallelizable.
    // eslint-disable-next-line no-await-in-loop
    ret = await fetchAssayBaseline({
      pipelineID,
      workspaceId,
      start,
      end,
      next,
      locations
    });
    // This await is not parallelizable.
    // eslint-disable-next-line no-await-in-loop
    ret_json = await ret.json();
  }
  return baselineLogs;
}

export default loadAllBaselineLogs;
